import React, { Component, Fragment } from 'react'
import '../../Css/SkeletonLoading.scss'

const SkeletonLoading = () => {
    return (
        <Fragment>
            <div className = "skeletonWrapper">
                &nbsp;
            </div>
        </Fragment>
    )
}
export default SkeletonLoading;